// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
  # product container 
*/
.productSlide_product__cjw5N {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.productSlide_product-inner__0HFI\\+ {
  width: 100%;
  max-width: 500px;
}
.productSlide_product-slide__FFUql {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  overflow: hidden;
  /* overflow-x: auto; */
}
.productSlide_placeholder-slide_container__8NZLV {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
  padding: 0 16px;
}
.productSlide_placeholder-slide__-Pdso:nth-child(3),
.productSlide_placeholder-slide__-Pdso:nth-child(4) {
  display: none;
}
.productSlide_more__rF4E1 {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  height: clamp(107px, 48.73vw, 358px);
}
.productSlide_more__rF4E1 span {
  border: 2px solid #ffd239;
  background: #06482d;
  box-shadow: -4px 3px 11px 0px rgba(0, 3, 15, 0.08),
    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
    -105px 67px 35px 0px rgba(0, 3, 15, 0);
  color: #ffd239;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 12px;
}
@media screen and (min-width: 1200px) {
  .productSlide_placeholder-slide__-Pdso:nth-child(3),
  .productSlide_placeholder-slide__-Pdso:nth-child(4) {
    display: flex;
  }
  .productSlide_product-inner__0HFI\\+ {
    max-width: 1150px;
    padding: 0 32px;
  }
  .productSlide_prev__pPTOY {
    left: -11px !important;
  }
  .productSlide_next__\\+gKgX {
    right: -11px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/products/slider/productSlide.module.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB;;;;0CAIwC;EACxC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE;;IAEE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* \n  # product container \n*/\n.product {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.product-inner {\n  width: 100%;\n  max-width: 500px;\n}\n.product-slide {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  overflow: hidden;\n  /* overflow-x: auto; */\n}\n.placeholder-slide_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 18px;\n  padding: 0 16px;\n}\n.placeholder-slide:nth-child(3),\n.placeholder-slide:nth-child(4) {\n  display: none;\n}\n.more {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  height: clamp(107px, 48.73vw, 358px);\n}\n.more span {\n  border: 2px solid #ffd239;\n  background: #06482d;\n  box-shadow: -4px 3px 11px 0px rgba(0, 3, 15, 0.08),\n    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n    -105px 67px 35px 0px rgba(0, 3, 15, 0);\n  color: #ffd239;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  height: 56px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  border-radius: 12px;\n}\n@media screen and (min-width: 1200px) {\n  .placeholder-slide:nth-child(3),\n  .placeholder-slide:nth-child(4) {\n    display: flex;\n  }\n  .product-inner {\n    max-width: 1150px;\n    padding: 0 32px;\n  }\n  .prev {\n    left: -11px !important;\n  }\n  .next {\n    right: -11px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product": `productSlide_product__cjw5N`,
	"product-inner": `productSlide_product-inner__0HFI+`,
	"product-slide": `productSlide_product-slide__FFUql`,
	"placeholder-slide_container": `productSlide_placeholder-slide_container__8NZLV`,
	"placeholder-slide": `productSlide_placeholder-slide__-Pdso`,
	"more": `productSlide_more__rF4E1`,
	"prev": `productSlide_prev__pPTOY`,
	"next": `productSlide_next__+gKgX`
};
export default ___CSS_LOADER_EXPORT___;
